new MutationObserver(ms => ms.forEach(m => {
  if (m.attributeName !== 'aria-hidden') return;
  const el = m.target, hide = el.getAttribute('aria-hidden') === 'true';
  el.querySelectorAll('a, input, button').forEach(c => {
    if (hide) { if (!c.hasAttribute('tabindex')) c.dataset.oh = '1'; c.tabIndex = -1; }
    else if (c.dataset.oh) { delete c.dataset.oh; c.removeAttribute('tabindex'); }
  });
})).observe(document, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });